import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import './input.css';

/* Input — one text field for the whole storefront. The price pair and the rail's
   search box are this control at two sizes; see input.css.

   It is always labelled: a field with a placeholder and no label is invisible to
   a screen reader once a shopper types into it, so `label` is required — pass
   `hideLabel` to keep it off screen rather than dropping it. */
const Input = forwardRef(function Input({
  label,
  hideLabel,
  icon: Icon,
  size,
  className,
  id,
  ...rest
}, ref) {
  const inputId = id || `sd-in-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;

  return (
    <div className={`sd-field${Icon ? ' sd-field-icon' : ''}${className ? ` ${className}` : ''}`}>
      {Icon && <Icon aria-hidden="true" />}
      <label
        htmlFor={inputId}
        className={hideLabel ? 'sd-sr-only' : undefined}
      >
        {label}
      </label>
      <input
        ref={ref}
        id={inputId}
        className={`sd-input${size === 'lg' ? ' sd-input-lg' : ''}`}
        {...rest}
      />
    </div>
  );
});

Input.propTypes = {
  /** Required — pass `hideLabel` to keep it visually hidden but announced. */
  label: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  /** A lucide icon component, drawn inside the leading edge. */
  icon: PropTypes.elementType,
  size: PropTypes.oneOf(['md', 'lg']),
  className: PropTypes.string,
  id: PropTypes.string,
};

Input.defaultProps = { size: 'md' };

export default Input;
